import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Collapse from '@material-ui/core/Collapse'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import { formatNumber } from 'libraries/utils'
import { updateCwWineNote, getWineData } from '../actions/asyncWines'
import { updateShippingCart } from '../actions/asyncOrders'

import WineStorageMember from './WineStorageMember'
import WineDetailDialog from './dialog/WineDetailDialog'
import AddShoppingCartDialog from './dialog/AddShoppingCartDialog'
import Tag from 'components/common/Tag'

const WineInfo = props => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false)
    const [showWineDetail, setShowWineDetail] = useState(false)
    const [showAddShoppingCart, setAddShowShoppingCart] = useState(false)
    const { wineDataMap, data, shippingCart } = props
    const cwWineId = data.id

    const handelShowWineDetail = () => {
        setShowWineDetail(!showWineDetail)
    }

    const onSaveDrinkNote = (comment) => {
        const wineId = data.storageMemberWine[0].memberWineId
        props.updateCwWineNote(wineId, comment, cwWineId, data.volume) // wineId, comment, cwWineId, volume
        // wineId: member wine id (any member wien id in the cw wine)
        setShowWineDetail(false)
    }

    const handelAddShoppingCart = () => {
        setAddShowShoppingCart(!showAddShoppingCart)
    }

    const addShoppingCart = (storageOrderItemIds) => {
        props.updateShippingCart(storageOrderItemIds)
    }

    // component did mount
    useEffect(() => {
        props.getWineData(cwWineId, data.volume) // cwWineId, volume
    },[])

    return (
        <Grid container className="wine-card">
            <Grid container style={{borderBottom: '2px solid rgba(74, 79, 85, 0.1)'}}>
                {/* wine photo */}
                <Grid item md={2}
                    className="wine-img"
                    style={{
                        backgroundImage: `url(${data.imageUrl})`,
                    }}
                />
                <Grid item md={10}>
                    <Grid container style={{ padding: '16px 24px'}}>
                        <Grid container>
                            {/* title */}
                            <Grid item md={10} style={{ paddingRight: '35px' }}>
                                <Typography className="card-title pointer" onClick={handelShowWineDetail}>
                                    {data.name}
                                </Typography>
                            </Grid>
                            <Grid item md={2} style={{ height: '100%', paddingLeft: '10px' }}>
                                <Typography variant="body2"
                                    style={{
                                        textAlign: 'center',
                                        color: '#1ec280',
                                        backgroundColor: 'rgba(30, 194, 128, 0.15)',
                                        borderRadius: '2px',
                                        padding: '2px 0',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    損益 {data.profitAndLoss} %
                                </Typography>
                            </Grid>
                        </Grid>

                        {/* tag */}
                        <Grid container style={{ marginTop: '5px', marginBottom: '24px' }}>
                            <Tag tagName={data.country} countryCode={data.countryCode}/>
                            <Tag tagName={data.vintage} />
                            <Tag tagName={t(`${data.color}_wine`)} color={data.color} />
                            <Tag tagName={!!data.style && t(`wine_type_${data.style}`)} />
                            <Tag tagName={`${data.volume} ml`} />
                            <Tag tagName={data.grape} grape />
                            <Tag tagName={data.region} />
                        </Grid>
                        <Grid container alignItems="flex-end" justify="space-between" className="wine-info">
                            <div className="display-flex">
                                <div className="info-item">
                                    <Typography variant="body2" style={{ color: '#9fa2a3' }}>
                                        {t('bottle_number')}
                                    </Typography>
                                    <Typography className="info-number">
                                        {data.totalQuantity}
                                    </Typography>
                                </div>
                                <div className="info-item">
                                    <Typography variant="body2" style={{ color: '#9fa2a3' }}>
                                        {t('est_value')}
                                    </Typography>
                                    <Typography className="info-number">
                                        <small>{t('TWD')}</small>
                                        {formatNumber(data.value)}
                                    </Typography>
                                </div>
                                {/* issue # */}
                                {/* <div className="info-item">
                                    <Typography variant="body2" style={{ color: '#9fa2a3' }}>
                                        {t('prediction_value')}
                                    </Typography>
                                    <Typography className="info-number">
                                        {t('prediction_down')}
                                    </Typography>
                                </div> */}
                                <div className="info-item">
                                    <Typography variant="body2" style={{ color: '#9fa2a3' }}>
                                        {t('avg_cost')}
                                    </Typography>
                                    <Typography className="info-number">
                                        {formatNumber(data.avgCost)}
                                    </Typography>
                                </div>
                            </div>
                            <Button variant="contained" color="primary" onClick={handelAddShoppingCart}>{t('add_to_shipping_cart')}</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Collapse in={expanded} timeout="auto" style={{ width: '100%' }}>
                {wineDataMap.has(cwWineId) &&
                    wineDataMap.getIn([cwWineId, 'storageMemberWine']).map((item, idx) => {
                        const storageMemberWine = {
                            ...data.storageMemberWine[idx],
                            ...item.toJS(),
                        }
                        return (
                            <WineStorageMember                                
                                key={item.get('memberWineId')}
                                data={storageMemberWine}
                                cwWineId={cwWineId}
                                volume={data.volume}
                            />
                        )
                    }
                )}
            </Collapse>
            <Grid container justify="center" style={{ backgroundColor: 'white', padding: '10px 0' }}>
                {expanded ?
                    <ExpandLess className="pointer" onClick={() => setExpanded(false)} />
                    : <ExpandMore className="pointer" onClick={() => setExpanded(true)} />
                }
            </Grid>
            <WineDetailDialog
                open={showWineDetail}
                onClose={handelShowWineDetail}
                onSaveDrinkNote={onSaveDrinkNote}
                data={wineDataMap.has(cwWineId) && wineDataMap.get(cwWineId).toJS()}
            />
            <AddShoppingCartDialog
                open={showAddShoppingCart}
                onClose={handelAddShoppingCart}
                addShoppingCart={addShoppingCart}
                shippingCart={shippingCart}
                allMemberWine={data.storageMemberWine.reduce((acc,curr) => {
                    return acc.concat(curr.storageOrderItems)
                } ,[])}
            />
        </Grid>
    )
}

export default connect(
    state => ({
        wineDataMap: state.wines.wineDataMap,
        shippingCart: state.orders.shippingCart,
    }),
    {
        updateCwWineNote,
        updateShippingCart,
        getWineData,
    }
)(WineInfo)